import { createSelector } from 'reselect';
import { getOperationalStatus } from './getOperationalStatus';
import { isHoldingOperationalStatus } from '../constants';

export const getHasHoldingOperationalStatus = createSelector(
  [getOperationalStatus],
  (status) => {
    return isHoldingOperationalStatus(status);
  }
);
